export const morningPulse = {
  status: "GREEN",
  timestamp: "07:58 AM",
  summary: "System nominal. 142 new signups overnight across both platforms. Ambassador Boss upgraded 3 MedSoc reps. Medical Guardian flagged 1 question for review in the UCAT Verbal Reasoning bank.",
  stats: {
    signups: 142,
    activeUsers: 3847,
    emailsSent: 89,
    agentsRunning: 11,
  }
};

export const signupData = [
  { day: "Mon", meduvita: 98, mmf: 34 },
  { day: "Tue", meduvita: 112, mmf: 41 },
  { day: "Wed", meduvita: 134, mmf: 56 },
  { day: "Thu", meduvita: 109, mmf: 38 },
  { day: "Fri", meduvita: 156, mmf: 63 },
  { day: "Sat", meduvita: 178, mmf: 72 },
  { day: "Sun", meduvita: 142, mmf: 58 },
];

export const retentionData = [
  { week: "W1", rate: 91 },
  { week: "W2", rate: 87 },
  { week: "W3", rate: 83 },
  { week: "W4", rate: 79 },
  { week: "W5", rate: 85 },
  { week: "W6", rate: 88 },
];

export const agents = [
  {
    id: "mit-engineer",
    name: "MIT Engineer",
    dept: "Product & Engineering",
    platform: "meduvita",
    status: "running",
    lastRun: "2 mins ago",
    nextRun: "58 mins",
    brain: "Gemini 2.5 Flash",
    trigger: "Hourly Cron",
    description: "Monitors site health, logs 404/500 errors, writes code patches.",
    todayActions: 3,
    logs: [
      { time: "07:00", msg: "Health check passed. All endpoints nominal.", type: "ok" },
      { time: "06:00", msg: "Health check passed. 1 slow query detected (>2s) on /quiz endpoint.", type: "warn" },
      { time: "05:00", msg: "Health check passed. All endpoints nominal.", type: "ok" },
    ]
  },
  {
    id: "medical-guardian",
    name: "Medical Guardian",
    dept: "Product & Engineering",
    platform: "meduvita",
    status: "flagged",
    lastRun: "14 mins ago",
    nextRun: "On DB write",
    brain: "Gemini 2.0 Pro",
    trigger: "On new DB row",
    description: "QA tester. Scans every new UCAT/USMLE question against 2026 NICE Guidelines.",
    todayActions: 1,
    logs: [
      { time: "07:44", msg: "⚠️ FLAGGED: Q#4821 Verbal Reasoning — Reference to NICE CG189 (outdated, superseded by NG238). Requires founder review.", type: "error" },
      { time: "06:21", msg: "Scanned 14 new questions. All compliant.", type: "ok" },
    ]
  },
  {
    id: "concierge",
    name: "The Concierge",
    dept: "Customer Love",
    platform: "meduvita",
    status: "running",
    lastRun: "Realtime",
    nextRun: "Always on",
    brain: "DocsBot AI",
    trigger: "Inbound email/chat",
    description: "Front-line support. Answers how-to queries. Escalates angry/complex tickets.",
    todayActions: 23,
    logs: [
      { time: "07:51", msg: "Resolved: 'How do I reset my streak?' → Sent help doc link.", type: "ok" },
      { time: "07:33", msg: "Resolved: 'When does the UCAT section update?' → Sent FAQ.", type: "ok" },
      { time: "07:12", msg: "ESCALATED: User expressed frustration about billing. Moved to your inbox.", type: "warn" },
    ]
  },
  {
    id: "early-warning",
    name: "Early Warning Scout",
    dept: "Customer Love",
    platform: "meduvita",
    status: "running",
    lastRun: "3 hrs ago",
    nextRun: "Tonight 11 PM",
    brain: "Gemini 2.5 Flash",
    trigger: "Nightly DB scan",
    description: "Detects quit risk. Emails targeted rescue content to struggling students.",
    todayActions: 7,
    logs: [
      { time: "23:00", msg: "Scanned 3,847 users. 7 identified as high quit-risk (Quantitative Reasoning < 40%). Rescue emails queued.", type: "ok" },
    ]
  },
  {
    id: "retentionist",
    name: "The Retentionist",
    dept: "Customer Love",
    platform: "meduvita",
    status: "running",
    lastRun: "1 hr ago",
    nextRun: "23 hrs",
    brain: "Gemini 2.5 Flash",
    trigger: "Daily inactive scan",
    description: "Manages 3-7-10-14 day cool nudge sequences with Gen-Z med humour.",
    todayActions: 34,
    logs: [
      { time: "07:00", msg: "Day-3 nudge sent to 18 users. Day-7 nudge sent to 9 users. Day-14 nudge sent to 7 users.", type: "ok" },
    ]
  },
  {
    id: "alchemist",
    name: "Meduvita Alchemist",
    dept: "Study Engine",
    platform: "meduvita",
    status: "running",
    lastRun: "On demand",
    nextRun: "On user click",
    brain: "Gemini 2.5 Flash + Python",
    trigger: "User clicks Generate Notes",
    description: "Converts wrong answers into Anki CSV decks or High-Yield PDF cheat sheets.",
    todayActions: 56,
    logs: [
      { time: "07:49", msg: "Generated Anki deck for user@nhs.net — 23 cards. Emailed.", type: "ok" },
      { time: "07:41", msg: "Generated High-Yield PDF for user2@medic.ac.uk. Emailed.", type: "ok" },
    ]
  },
  {
    id: "matchmaker",
    name: "The Matchmaker",
    dept: "Study Engine",
    platform: "meduvita",
    status: "idle",
    lastRun: "3 days ago",
    nextRun: "Sunday 9 AM",
    brain: "Supabase Logic",
    trigger: "Weekly clustering",
    description: "Groups students struggling with same topics into temporary Study Rooms.",
    todayActions: 0,
    logs: [
      { time: "Sun 09:00", msg: "Formed 6 study groups. 34 students invited across Verbal Reasoning & QR topics.", type: "ok" },
    ]
  },
  {
    id: "marketing-scout",
    name: "Head of Marketing (Scout)",
    dept: "Marketing & Growth",
    platform: "mmf",
    status: "running",
    lastRun: "58 mins ago",
    nextRun: "Tomorrow 8 AM",
    brain: "Web Scraper + Gemini Flash",
    trigger: "Daily 8:00 AM",
    description: "Scrapes Medify pricing, TikTok trends. Writes your daily Reel script.",
    todayActions: 1,
    logs: [
      { time: "08:00", msg: "Competitor scan: Medify unchanged. New TikTok trend: 'POV: UCAT day -1'. Daily script generated and dropped in Studio Panel.", type: "ok" },
    ]
  },
  {
    id: "brand-alchemist",
    name: "Brand Alchemist",
    dept: "Marketing & Growth",
    platform: "mmf",
    status: "idle",
    lastRun: "2 days ago",
    nextRun: "On video upload",
    brain: "CapCut AI / Fliki AI",
    trigger: "On video upload",
    description: "Auto-clips webinar recordings into 5 TikToks + SEO blog posts.",
    todayActions: 0,
    logs: [
      { time: "2d ago", msg: "Processed: MMF-Webinar-Apr16.mp4 → 5 clips ready, 1 blog post drafted.", type: "ok" },
    ]
  },
  {
    id: "ambassador-boss",
    name: "Ambassador Boss",
    dept: "Marketing & Growth",
    platform: "mmf",
    status: "running",
    lastRun: "3 hrs ago",
    nextRun: "On referral",
    brain: "Gumloop workflow",
    trigger: "Referral link activation",
    description: "Manages MedSoc reps. Auto-upgrades accounts when referral targets are hit.",
    todayActions: 3,
    logs: [
      { time: "05:12", msg: "Rep @king_s_medsoc hit 10 referrals → Account upgraded to Premium. Email sent.", type: "ok" },
      { time: "03:44", msg: "Rep @ucl_medsoc hit 10 referrals → Account upgraded to Premium. Email sent.", type: "ok" },
      { time: "01:20", msg: "Rep @edinburgh_med hit 10 referrals → Account upgraded to Premium. Email sent.", type: "ok" },
    ]
  },
  {
    id: "chief-of-staff",
    name: "Chief of Staff",
    dept: "Command",
    platform: "both",
    status: "running",
    lastRun: "Just now",
    nextRun: "Tomorrow 7:55 AM",
    brain: "Gemini 2.5 Pro",
    trigger: "Daily 7:55 AM",
    description: "Aggregates all agent outputs. Writes the Morning Pulse. Flags your priorities.",
    todayActions: 1,
    logs: [
      { time: "07:55", msg: "Morning Pulse generated. 1 priority flag: Medical Guardian review needed.", type: "ok" },
    ]
  },
];

export const approvalQueue = [
  {
    id: "email-001",
    agent: "Retentionist",
    platform: "meduvita",
    subject: "Day 7 Nudge — We miss your brain 🧠",
    preview: "Hey [First Name], it's been a week. We get it — med school is brutal. But your UCAT date isn't moving. We saved your progress. Come back for just 15 mins today?",
    recipients: 9,
    status: "pending",
    createdAt: "07:01 AM",
  },
  {
    id: "email-002",
    agent: "Early Warning Scout",
    platform: "meduvita",
    subject: "You're struggling with QR — here's what actually helps",
    preview: "We noticed you've scored under 550 on Quantitative Reasoning 3 times this week. That's not a you problem — it's a strategy problem. Here's the exact video that helped 847 students crack it...",
    recipients: 7,
    status: "pending",
    createdAt: "11:03 PM",
  },
  {
    id: "email-003",
    agent: "Ambassador Boss",
    platform: "mmf",
    subject: "🎉 You hit 10 referrals! Welcome to Premium.",
    preview: "Congrats [Rep Name]! Your MedSoc hustle just paid off. You've been automatically upgraded to Premium. Your students are thanking you — and so are we.",
    recipients: 3,
    status: "pending",
    createdAt: "05:15 AM",
  },
];

export const escalations = [
  {
    id: "esc-001",
    from: "sarah.johnson@kcl.ac.uk",
    subject: "Partnership proposal — King's College Medicine Society",
    preview: "Hi, I'm the President of KCL MedSoc. We'd love to discuss an exclusive partnership for our 400+ members ahead of the UCAT season...",
    type: "partnership",
    urgency: "high",
    time: "2 hrs ago",
    platform: "meduvita",
  },
  {
    id: "esc-002",
    from: "angry.user@gmail.com",
    subject: "Charged twice — this is unacceptable",
    preview: "I was charged twice this month. I've emailed 3 times with no response. If this isn't fixed today I'm disputing with my bank...",
    type: "billing",
    urgency: "critical",
    time: "45 mins ago",
    platform: "meduvita",
  },
  {
    id: "esc-003",
    from: "dr.patel@nhs.net",
    subject: "Interest in MMF for FY1 doctors",
    preview: "I'm a consultant at UCLH and I think My Medicine Friend could be incredibly useful for our foundation year doctors. Could we arrange a call?",
    type: "partnership",
    urgency: "high",
    time: "4 hrs ago",
    platform: "mmf",
  },
];

export const studioPanel = {
  script: `🎬 TODAY'S REEL SCRIPT — Generated by Marketing Scout at 8:00 AM

HOOK (0–3s):
"POV: It's UCAT day minus 1 and you're doing THIS instead of panicking 👇"

BODY (3–25s):
[Show screen of Meduvita dashboard]
"While everyone else is cramming 200 random questions, you've got the Alchemist sending you a personalised Anki deck of your ACTUAL weak spots."

"Your AI literally studied you studying. That's not cheating. That's just smarter."

CTA (25–30s):
"Link in bio. It's free. Your competitors aren't ready."

📊 TREND INTEL:
- Hook format: "POV: UCAT day -1" — trending +340% this week
- Competitor Medify: No pricing changes detected
- Suggested post time: 6:30 PM (peak med student scroll time)
- Recommended audio: 'chill-study-lofi' trending on TikTok MedTok`,
  generatedAt: "08:00 AM",
  trendScore: 94,
};

export const ambassadors = [
  { name: "@kings_medsoc", uni: "King's College London", referrals: 23, status: "premium", revenue: "£460" },
  { name: "@ucl_medsoc", uni: "University College London", referrals: 19, status: "premium", revenue: "£380" },
  { name: "@edinburgh_med", uni: "University of Edinburgh", referrals: 14, status: "premium", revenue: "£280" },
  { name: "@oxford_medsoc", uni: "University of Oxford", referrals: 8, status: "active", revenue: "£160" },
  { name: "@bristol_med", uni: "University of Bristol", referrals: 5, status: "active", revenue: "£100" },
  { name: "@manchester_medsoc", uni: "University of Manchester", referrals: 2, status: "active", revenue: "£40" },
];
